import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { EventRequestById } from "../../models/event";
import { IApiErrorSuccessDTO } from "../../models/apiErrorSuccess";
import { RequestSourceTypeEnum } from "../../models/request";
import { mockedWorkordersGetEventsById } from "./event-api.mock-constants";
import { EventApi } from "./event-api.models";
import { IEventPropertiesDTO } from "./event-api.service";

@Injectable()
export class MockEventApiService extends EventApi {
  constructor() {
    super();
  }

  public getEventsByWorkorderId(id: number): Observable<EventRequestById[]> {
    const events: EventRequestById[] = mockedWorkordersGetEventsById.filter(
      (a) => a.requestId === +id,
    );
    return of(events);
  }

  public addEventByWorkorderId(
    id: number,
    event: EventRequestById,
  ): Observable<EventRequestById> {
    const eventToPush = {
      ...event,
      requestId: id,
      creationDate: new Date(),
      userFirstName: "firstName",
      userLastName: "lastName",
    };
    mockedWorkordersGetEventsById.push(eventToPush);
    return of(eventToPush);
  }

  public postTakeInCharge(
    ids: number[],
    responsibleUser?: string,
  ): Observable<IApiErrorSuccessDTO> {
    const returnValue: IApiErrorSuccessDTO = {};
    returnValue.success = ids.map((id) => {
      return { dddId: 9 };
    });
    return of(returnValue);
  }

  public postCancelTakeInCharge(
    ids: number[],
  ): Observable<IApiErrorSuccessDTO> {
    const returnValue: IApiErrorSuccessDTO = {};
    returnValue.success = ids.map((id) => {
      return { dddId: 3277441 };
    });
    return of(returnValue);
  }

  public postChangeActivity(
    eventProperties: IEventPropertiesDTO,
  ): Observable<IApiErrorSuccessDTO> {
    const returnValue: IApiErrorSuccessDTO = {};
    returnValue.success = eventProperties.requestIds.map((id) => {
      return eventProperties.requestType ===
        RequestSourceTypeEnum.workorderRequest
        ? { dddId: id }
        : { ddsId: id };
    });
    return of(returnValue);
  }

  public postChangeResponsible(
    ids: number[],
    responsibleUser: string,
    requestType: RequestSourceTypeEnum,
  ): Observable<IApiErrorSuccessDTO> {
    const returnValue: IApiErrorSuccessDTO = {};
    returnValue.success = ids.map((id) => {
      return requestType === RequestSourceTypeEnum.workorderRequest
        ? { dddId: id }
        : { ddsId: id };
    });
    return of(returnValue);
  }

  public postCloseWorkorder(
    eventProperties: IEventPropertiesDTO,
  ): Observable<IApiErrorSuccessDTO> {
    const returnValue: IApiErrorSuccessDTO = {};
    returnValue.success = eventProperties.requestIds.map((id) => {
      return eventProperties.requestType ===
        RequestSourceTypeEnum.workorderRequest
        ? { ddsId: id }
        : { ddsId: id };
    });
    return of(returnValue);
  }
}
